import {
  type SanityFrameBuilderArtworkPreviewStrings,
  type SanityFrameBuilderArtworkSizeStrings,
  type SanityFrameBuilderControlsStrings,
  type SanityFrameBuilderFrameStyleStrings,
  type SanityFrameBuilderGlassStrings,
  type SanityFrameBuilderPassepartoutStrings,
  type SanityFrameBuilderSpacerStrings,
  type SanityFrameBuilderStrings,
} from '@frame-builder/data/sanity/queries/types/strings'

const emptyFrameBuilderArtworkSizeStrings: SanityFrameBuilderArtworkSizeStrings =
  {
    artworkSizeStepTitle: '',
    artworkSizeSizeNotValid: '',
    artworkSizeWidthAndHeightDescription: [],
    artworkSizeNoSelection: '',
    artworkSizeNoWidthSelected: '',
    artworkSizeNoHeightSelected: '',
    artworkSizeOutOfProfileLimits: '',
    artworkSizeStandardSizeMessage: '',
    artworkSizeStandardSizeLinkText: '',
    artworkSizeStepFooter: [],
  }

const emptyFrameBuilderArtworkPreviewStrings: SanityFrameBuilderArtworkPreviewStrings =
  {
    artworkPreviewStepTitle: '',
    artworkPreviewArtworkDescription: [],
    artworkPreviewNoSelection: '',
    artworkPreviewStepFooter: [],
  }

const emptyFrameBuilderFrameStyleStrings: SanityFrameBuilderFrameStyleStrings =
  {
    frameStyleStepTitle: '',
    frameStyleProfileNotValid: '',
    frameStyleTextureNotValid: '',
    frameStyleTextureDescription: [],
    frameStyleProfileDescription: [],
    frameStyleStepFooter: [],
  }

const emptyFrameBuilderPassepartoutStrings: SanityFrameBuilderPassepartoutStrings =
  {
    passepartoutStepTitle: '',
    passepartoutSizeNotValid: '',
    passepartoutNoPassepartoutTitle: '',
    passepartoutColorNotValid: '',
    passepartoutStepFooter: [],
  }

const emptyFrameBuilderGlassStrings: SanityFrameBuilderGlassStrings = {
  glassStepTitle: '',
  glassTypeNotValid: '',
  glassTypeDescription: [],
  glassStepFooter: [],
}

const emptyFrameBuilderSpacerStrings: SanityFrameBuilderSpacerStrings = {
  spacerStepTitle: '',
  spacerSizeNotValid: '',
  spacerColorNotValid: '',
  spacerStepFooter: [],
}

const emptyFrameBuilderControlsStrings: SanityFrameBuilderControlsStrings = {
  discountPercentLabel: '',
  controlCancelLabel: '',
  controlOkLabel: '',
  controlChooseProductHint: '',
  controlAddToCartHint: '',
  controlQuantityLabel: '',
  controlPriceLabel: '',
  chooseFileLabel: '',
  lengthUnitLabel: '',
}

export const emptyFrameBuilderStrings: SanityFrameBuilderStrings = {
  ...emptyFrameBuilderArtworkSizeStrings,
  ...emptyFrameBuilderArtworkPreviewStrings,
  ...emptyFrameBuilderFrameStyleStrings,
  ...emptyFrameBuilderPassepartoutStrings,
  ...emptyFrameBuilderGlassStrings,
  ...emptyFrameBuilderSpacerStrings,
  ...emptyFrameBuilderControlsStrings,
  frameDimensionsHeading: '',
  passepartoutDimensionsHeading: '',
  addProductError: '',
}
